// Components
import { IconComponent } from '@centria-ui-atoms/icon-component'
import { Typography } from '@centria-ui-atoms/typography'
import { Skeleton } from '@centria-ui-atoms/skeleton'

// Prime Components
import { MultiSelect as PrMultiSelect } from 'primereact/multiselect'

// Styles
import classes from './styles.module.scss'

// Types
import type { MultiSelectProps as PrMultiSelectProps } from 'primereact/multiselect'
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { IconName } from '@centria-ui-atoms/icon-component'
import type { FC } from 'react'

export interface MultiSelectProps extends PrMultiSelectProps {
  label?: string
  icon?: IconName
  hideHeader?: boolean
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const MultiSelect: FC<MultiSelectProps> = ({
  icon,
  label,
  hideHeader,
  className = '',
  display = 'chip',
  inputColor = 'light',
  inputVariant = 'block',
  ...props
}) => {
  const append = () => {
    if (typeof document !== 'undefined') return document.body
    else return 'self'
  }

  return (
    <div data-cy='multi-select'>
      {label && (
        <Typography
          Tag='label'
          fontSize='small'
          className='mb-1'
          htmlFor={props.id}>
          {label}
        </Typography>
      )}
      {!props?.options ? (
        <div className='d-flex'>
          <Skeleton height='48px' width='100%' radius='lg' />
        </div>
      ) : (
        <div className={`${classes.multiSelectContainer} ${className}`}>
          <div
            className={`p-input-icon-left ${classes.multiSelectBar} ${
              classes[`multiSelectBar_${inputVariant}`]
            } ${classes[`multiSelectBar_${inputColor}`]}`}>
            {icon && <IconComponent icon={icon} className={classes.icon} />}
            <PrMultiSelect
              display={display}
              appendTo={append()}
              className={classes.multiSelect}
              panelClassName={`${classes.multiSelectPanel} ${
                hideHeader && classes.hideHeader
              }`}
              {...props}
            />
          </div>
        </div>
      )}
    </div>
  )
}
